import { useContext } from 'react';

import { DistributionFlowContext } from './Controller';

export const useDistributionFlow = () => {
  const ctx = useContext(DistributionFlowContext);
  if (!ctx) throw new Error('useDistributionFlow must be used within DistributionFlowProvider');
  return ctx;
};
